import $ from "jquery";
import Siema from "siema";
require("jquery.scrollto");
require("jquery-visible");
// import InView from "inview";
import GLightbox from "glightbox";
function debounce(func, wait, immediate) {
    var timeout;
    return function () {
        var context = this, args = arguments;
        var later = function () {
            timeout = null;
            if (!immediate)
                func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow)
            func.apply(context, args);
    };
}
;
$(document).ready(function () {
    if ($('.page-template-tpl-order').length) {
        var lightbox = GLightbox({
            touchNavigation: true
        });
        var orderHeaderTab_1 = document.getElementById('order_header_tab');
        var headerTab_1 = $('.header_tab > div > ul');
        var scrollBarSize_1 = 0;
        var scrollPosition_1 = [];
        var headerOffset_1 = headerTab_1.offset();
        headerTab_1.children("li").each(function (k, v) {
            scrollBarSize_1 += $(v).outerWidth();
            scrollPosition_1.push($(v).offset().left - headerOffset_1.left);
        });
        // let menuInView = InView('.menu-section', (isInView, data) => {
        //     if (isInView) {
        //         console.log(data);
        //     }
        // });
        var viewport_1 = 600;
        if ($(window).height() < 700) {
            viewport_1 = 300;
        }
        $('.menu-section').each(function (k, v) {
            var debounced = debounce(function () {
                var rect = v.getBoundingClientRect();
                if (rect.top > 0 && rect.top < viewport_1 && !$(v).hasClass("active")) {
                    $(v).addClass("active");
                    var index = $(v).data("index");
                    headerTab_1.children('li.current').removeClass("current");
                    headerTab_1.children('li:eq(' + (index - 1) + ')').addClass("current");
                    orderHeaderTab_1.scrollLeft = scrollPosition_1[index - 1];
                }
                else {
                    $(v).removeClass("active");
                }
            }, 50);
            $(document).scroll(debounced);
        });
        $('.header_tab').on("click", "a", function (e) {
            e.preventDefault();
            var elm = $(e.currentTarget);
            var parent = elm.parent();
            if (scrollPosition_1[parent.index() - 1] !== void 0) {
                orderHeaderTab_1.scrollLeft = scrollPosition_1[parent.index() - 1];
            }
            var node = $(e.currentTarget).attr("href");
            if ($(node).length) {
                var posY = $(node).offset().top - ($("#main-header").height() + $("main > .header_tab").height() + $("main > .informations").height());
                if (posY >= 0) {
                    $.scrollTo(posY, 400);
                }
            }
        });
        var parent = $('.siema');
        if (parent.length) {
            var sizes_1 = [];
            $('.siema').children().each(function (k, v) {
                sizes_1.push($(v).find(".dishes").height() + 200);
            });
            var siema_1 = new Siema({
                onInit: function () {
                    if ($(window).width() < 568) {
                        $('.siema').height(sizes_1[0]);
                    }
                },
                onChange: function () {
                    if ($(window).width() < 568) {
                        $('.siema').height(sizes_1[siema_1.currentSlide]);
                    }
                    else {
                        $('.siema').css({ height: "auto" });
                    }
                    headerTab_1.children('li.current').removeClass("current");
                    headerTab_1.children('li:eq(' + siema_1.currentSlide + ')').addClass("current");
                    if ($(window).width() < 500) {
                        orderHeaderTab_1.scrollLeft = headerTab_1.find(".current").position().left;
                    }
                    else {
                        orderHeaderTab_1.scrollLeft = headerTab_1.find(".current").offset().left - headerTab_1.offset().left - 40;
                    }
                }
            });
            headerTab_1.on("click", "a", function (e) {
                e.preventDefault();
                var index = $(e.currentTarget).parent('li').index();
                siema_1.goTo(index);
            });
        }
    }
});
